// extracted by mini-css-extract-plugin
export var breadcrumbs = "style-module--breadcrumbs--2716b";
export var catalog = "style-module--catalog--03760";
export var chevron = "style-module--chevron--69cba";
export var crumbUrl = "style-module--crumbUrl--7e227";
export var slashIcon = "style-module--slashIcon--51b6a";